/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { eventStatus } from '../constants';
import FilterSelect from './FilterSelect';
import DepartemplSelect from '../pages/options/DepartemplSelect';
import { Grid } from '@material-ui/core';
import useEmployees from '../hooks/useEmployees';
import useDepartments from '../hooks/useDepartments';
import { useTemplate } from '../hooks';

export default function EventsCalFilter({
  departvalue,
  setDepartvalue,
  emplvalue,
  setEmplvalue,
  status,
  setStatus,
  mainResourceName,
  setMainResourceName,
  words,
  isRTL,
  count,
  theme,
  refresh,
  setResourseData,
  loading,
}: any) {
  const { employees } = useEmployees();
  const { departments } = useDepartments();
  const { calendaroptions, tempoptions } = useTemplate();
  return (
    <Grid container spacing={2}>
      {calendaroptions?.emplfilter && tempoptions?.employee && (
        <Grid item xs={3}>
          <FilterSelect
            options={employees}
            value={emplvalue}
            setValue={setEmplvalue}
            words={words}
            isRTL={isRTL}
            name="employee"
            fullWidth
          ></FilterSelect>
        </Grid>
      )}
      {/* {calendaroptions?.departfilter && tempoptions?.department && (
        <Grid item xs={2}>
          <FilterSelect
            options={departments.filter((d: any) => d.depType === 1)}
            value={departvalue}
            setValue={setDepartvalue}
            words={words}
            isRTL={isRTL}
            name="department"
            fullWidth
          ></FilterSelect>
        </Grid>
      )} */}
      {calendaroptions?.statusfilter && (
        <Grid item xs={3}>
          <FilterSelect
            options={eventStatus}
            value={status}
            setValue={setStatus}
            words={words}
            isRTL={isRTL}
            name="status"
            fullWidth
          ></FilterSelect>
        </Grid>
      )}
      <Grid item xs={6}>
        <DepartemplSelect
          value={mainResourceName}
          setValue={setMainResourceName}
          setResourseData={setResourseData}
          isRTL={isRTL}
          count={count}
          theme={theme}
          refresh={refresh}
          employees={employees}
          departments={departments}
          loading={loading}
          tempoptions={tempoptions}
        ></DepartemplSelect>
      </Grid>
    </Grid>
  );
}
